/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Import_Csv_ImportingInputs */



/**
* | output |
* | --- |
* | "Importing..." |
*
* @param {Datasets_Import_Csv_ImportingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_importing = /** @type {((inputs?: Datasets_Import_Csv_ImportingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_ImportingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird importiert...")
	return /** @type {LocalizedString} */ ("Importing...")
});